document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initGaleriaProducto();
  initVariantes();
  initComparador();
});

function initReveal() {
  var elementos = document.querySelectorAll('.fp-reveal');
  if (!elementos.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach(function (el) { el.classList.add('fp-visible'); });
    return;
  }
  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('fp-visible');
          observador.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  elementos.forEach(function (el) { observador.observe(el); });
}

function initContador() {
  var contadores = document.querySelectorAll('[data-fp-contador]');
  if (!contadores.length) return;
  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        var el = entrada.target;
        var fin = parseFloat(el.getAttribute('data-fp-contador'));
        var duracion = 1400;
        var inicio = null;
        function animar(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / duracion, 1);
          var valor = Math.floor(progreso * fin);
          el.textContent = valor.toLocaleString('es-ES');
          if (progreso < 1) requestAnimationFrame(animar);
          else el.textContent = fin.toLocaleString('es-ES');
        }
        requestAnimationFrame(animar);
        observador.unobserve(el);
      });
    },
    { threshold: 0.5 }
  );
  contadores.forEach(function (el) { observador.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-fp-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-fp-galeria-principal]');
  var miniaturas = galeria.querySelectorAll('[data-fp-miniatura]');
  if (!principal || !miniaturas.length) return;
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      if (!src) return;
      principal.setAttribute('src', src);
      miniaturas.forEach(function (m) { m.classList.remove('fp-miniatura-activa'); });
      mini.classList.add('fp-miniatura-activa');
    });
  });
}

function initVariantes() {
  var formulario = document.querySelector('[data-fp-form-producto]');
  if (!formulario) return;
  var datosEl = formulario.querySelector('[data-fp-variantes-json]');
  if (!datosEl) return;
  var variantes;
  try {
    variantes = JSON.parse(datosEl.textContent);
  } catch (e) {
    return;
  }
  var selects = formulario.querySelectorAll('[data-fp-opcion]');
  if (!selects.length) return;

  function variantePorSelección() {
    var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
    return variantes.find(function (v) {
      return v.opciones.every(function (op, i) { return op === valores[i]; });
    });
  }

  function actualizar() {
    var variante = variantePorSelección();
    var inputId = formulario.querySelector('[data-fp-variant-id]');
    var precioEl = formulario.querySelector('[data-fp-precio]');
    var precioComparadoEl = formulario.querySelector('[data-fp-precio-comparado]');
    var botón = formulario.querySelector('[data-fp-add]');
    if (!variante) {
      if (botón) { botón.disabled = true; botón.textContent = formulario.getAttribute('data-fp-texto-no-disponible'); }
      return;
    }
    if (inputId) inputId.value = variante.id;
    if (precioEl) precioEl.textContent = variante.precio_formateado;
    if (precioComparadoEl) {
      if (variante.precio_comparado_formateado) {
        precioComparadoEl.textContent = variante.precio_comparado_formateado;
        precioComparadoEl.style.display = '';
      } else {
        precioComparadoEl.style.display = 'none';
      }
    }
    if (botón) {
      if (variante.disponible) {
        botón.disabled = false;
        botón.textContent = formulario.getAttribute('data-fp-texto-comprar');
      } else {
        botón.disabled = true;
        botón.textContent = formulario.getAttribute('data-fp-texto-agotado');
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

function initComparador() {
  var comparadores = document.querySelectorAll('[data-fp-comparador]');
  comparadores.forEach(function (comp) {
    var asa = comp.querySelector('[data-fp-comparador-asa]');
    var despues = comp.querySelector('[data-fp-comparador-despues]');
    if (!asa || !despues) return;
    var arrastrando = false;

    function mover(clientX) {
      var rect = comp.getBoundingClientRect();
      var porcentaje = Math.min(Math.max(((clientX - rect.left) / rect.width) * 100, 0), 100);
      despues.style.clipPath = 'inset(0 ' + (100 - porcentaje) + '% 0 0)';
      asa.style.left = porcentaje + '%';
    }

    asa.addEventListener('pointerdown', function (e) { arrastrando = true; asa.setPointerCapture(e.pointerId); });
    window.addEventListener('pointerup', function () { arrastrando = false; });
    comp.addEventListener('pointermove', function (e) { if (arrastrando) mover(e.clientX); });
    comp.addEventListener('click', function (e) { mover(e.clientX); });
  });
}
